export const messages = {
  en: {
    addParkingSpaceApply: {
      title: 'Parking Space Application',
      carNum: 'License Plate',
      carType: 'Vehicle Type',
      parkingArea: 'Parking Lot',
      applyPersonName: 'Applicant',
      applyPersonLink: 'Applicant Phone',
      remark: 'Remarks',
      requiredCarNum: 'License plate is required',
      invalidCarNum: 'Invalid license plate format',
      requiredCarType: 'Vehicle type is required',
      requiredParkingArea: 'Parking lot is required',
      requiredApplyPersonName: 'Applicant name is required',
      maxApplyPersonName: 'Applicant name max 64 characters',
      requiredApplyPersonLink: 'Applicant phone is required',
      maxApplyPersonLink: 'Applicant phone max 11 characters',
      maxRemark: 'Remarks max 300 characters',
      placeholderCarNum: 'Required, please enter license plate',
      placeholderCarType: 'Required, please select vehicle type',
      placeholderParkingArea: 'Required, please select parking lot',
      placeholderApplyPersonName: 'Required, please enter applicant',
      placeholderApplyPersonLink: 'Required, please enter applicant phone',
      placeholderRemark: 'Optional, please enter remarks',
      selectOwner: 'Select Owner',
    }
  },
  zh: {
    addParkingSpaceApply: {
      title: '车位申请',
      carNum: '车牌号',
      carType: '车辆类型',
      parkingArea: '停车场',
      applyPersonName: '申请人',
      applyPersonLink: '申请人电话',
      remark: '备注',
      requiredCarNum: '车牌号不能为空',
      invalidCarNum: '车牌号格式错误',
      requiredCarType: '车辆类型不能为空',
      requiredParkingArea: '停车场不能为空',
      requiredApplyPersonName: '申请人不能为空',
      maxApplyPersonName: '申请人名称不能超过64位',
      requiredApplyPersonLink: '申请人电话不能为空',
      maxApplyPersonLink: '申请人电话不能超过11位',
      maxRemark: '备注不能超过300位',
      placeholderCarNum: '必填，请填写车牌号',
      placeholderCarType: '必填，请选择车辆类型',
      placeholderParkingArea: '必填，请选择停车场',
      placeholderApplyPersonName: '必填，请填写申请人',
      placeholderApplyPersonLink: '必填，请填写申请人电话',
      placeholderRemark: '选填，请填写备注',
      selectOwner: '选择车主',
    }
  },
  'zh-TW': {
    addParkingSpaceApply: {
      title: '車位申請',
      carNum: '車牌號',
      carType: '車輛類型',
      parkingArea: '停車場',
      applyPersonName: '申請人',
      applyPersonLink: '申請人電話',
      remark: '備註',
      requiredCarNum: '車牌號不能為空',
      invalidCarNum: '車牌號格式錯誤',
      requiredCarType: '車輛類型不能為空',
      requiredParkingArea: '停車場不能為空',
      requiredApplyPersonName: '申請人不能為空',
      maxApplyPersonName: '申請人名稱不能超過64位',
      requiredApplyPersonLink: '申請人電話不能為空',
      maxApplyPersonLink: '申請人電話不能超過11位',
      maxRemark: '備註不能超過300位',
      placeholderCarNum: '必填，請填寫車牌號',
      placeholderCarType: '必填，請選擇車輛類型',
      placeholderParkingArea: '必填，請選擇停車場',
      placeholderApplyPersonName: '必填，請填寫申請人',
      placeholderApplyPersonLink: '必填，請填寫申請人電話',
      placeholderRemark: '選填，請填寫備註',
      selectOwner: '選擇車主',
    }
  }
}